import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppMaterialModule } from '../appMaterial/app-material.module';
import { FormsModule } from '@angular/forms';
import { GoogleAnalyticsReportingComponent } from './google-analytics-reporting/google-analytics-reporting.component';
import { SharedIntegrationsComponent } from './shared-integrations.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { GoogleAnalyticsComponent } from './google-analytics/google-analytics.component';
import { GoogleAdsComponent } from './google-ads/google-ads.component';
import { NexmoComponent } from './nexmo/nexmo.component';
import { TwilioComponent } from './twilio/twilio.component';
import { ZohoComponent } from './zoho/zoho.component';
import { FacebookComponent } from './facebook/facebook.component';
import { AmazonComponent } from './amazon/amazon.component';
import { TwitterComponent } from './twitter/twitter.component';
import { SnapchatComponent } from './snapchat/snapchat.component';
import { BingComponent } from './bing/bing.component';
import { TradeDeskComponent } from './trade-desk/trade-desk.component';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { GoogleDriveComponent } from './google-drive/google-drive.component';
import { S3Component } from './s3/s3.component';
import { SharedModule } from '../shared.module';
import { TrackingTagComponent } from './tracking-tag/tracking-tag.component';
import { IntegratorDetailsComponent } from './integrator-details/integrator-details.component';
import { ManageIntegrationsComponent } from '../../portal/onboarding/manage/manage.component';
import { ManageModule } from '../../portal/onboarding/manage/manage.module';
import { RouterModule } from '@angular/router';
import {GoogleAdsReadOnlyComponent} from "./google-ads-read-only/google-ads-read-only.component";
import {FtpComponent} from "./ftp/ftp.component";
import {FtpDuplicateModule} from "./ftp/ftpDuplicate.module";
import {MatTreeModule} from "@angular/material/tree";

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

@NgModule({
  imports: [
    CommonModule,
    AppMaterialModule,
    FormsModule,
    FlexLayoutModule.withConfig({useColumnBasisZero: false}),
    NgxMaskModule.forRoot(),
    SharedModule,
    ManageModule,
    RouterModule,
    FtpDuplicateModule,
    MatTreeModule
  ],
    exports: [SharedIntegrationsComponent],
    declarations: [
        SharedIntegrationsComponent,
        GoogleAnalyticsComponent,
        GoogleAnalyticsReportingComponent,
        GoogleAdsComponent,
        GoogleAdsReadOnlyComponent,
        NexmoComponent,
        TwilioComponent,
        ZohoComponent,
        FacebookComponent,
        AmazonComponent,
        TwitterComponent,
        SnapchatComponent,
        BingComponent,
        TradeDeskComponent,
        GoogleDriveComponent,
        S3Component,
        FtpComponent,
        TrackingTagComponent,
        IntegratorDetailsComponent
    ],
    providers: []
})
export class SharedIntegrationsModule {}
